import { useMemo } from 'react';

interface RateGroupWithVisibleItems<TRoomGroup, TRateGroup, TItem> {
  roomGroup: TRoomGroup;
  rateGroup: TRateGroup;
  visibleItems: Array<TItem>;
}

export function useHideExpiredRateGroups<TRoomGroup extends { rateGroups: Array<TRateGroup> }, TRateGroup, TItem>(
  roomGroups: Array<TRoomGroup>,
  getItems: (rateGroup: TRateGroup) => Array<TItem>,
  isExpired: (item: TItem) => boolean,
  hideExpired: boolean,
): Array<RateGroupWithVisibleItems<TRoomGroup, TRateGroup, TItem>> {
  return useMemo(
    () =>
      roomGroups.flatMap((roomGroup) =>
        roomGroup.rateGroups.map((rateGroup) => ({
          roomGroup,
          rateGroup,
          visibleItems: hideExpired ? getItems(rateGroup).filter((item) => !isExpired(item)) : getItems(rateGroup),
        })),
      ),
    [roomGroups, getItems, isExpired, hideExpired],
  );
}
